export enum DelaroPrograms {
  DELARO_2020 = 'e0100f49-c86a-4b33-b922-a147bdcc5684',
  DELARO_2021 = 'a566e738-6a67-4635-8db0-28335583f178',
  DELARO_2022 = '2af52598-3ffa-4ec1-a441-617db0c3b7aa',
}

export enum Programs {
  DELARO_2020 = 'e0100f49-c86a-4b33-b922-a147bdcc5684',
  DELARO_2021 = 'a566e738-6a67-4635-8db0-28335583f178',
  DELARO_2022 = '2af52598-3ffa-4ec1-a441-617db0c3b7aa',
}
